// Another app's "sign in with the intranet" step (Meet Recorder, Protoboard, ...) sends a signed-out person to
// /login?next=<the step's address>. After they sign in they go back there, so they land in the app they came
// from instead of on the intranet's home page. Only an address on this same site is followed: anything else
// (another site, javascript:, a malformed value) is ignored and the person simply lands on home as before.
export function returnAddress(search, origin) {
  const next = new URLSearchParams(search).get("next");
  if (!next) return null;
  try {
    const url = new URL(next, origin);
    return url.origin === origin ? url.href : null;
  } catch {
    return null;
  }
}
